module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@3x-c09bf52d9fec5984a75c38c515f3c840.png";